module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/sIxX6G/tc-custom/9783968658346.jpg?1703042122957",
      "alt": "This image is the cover for the book Tarzan und die Weiße Frau, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Tarzan und die Weiße Frau, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Tarzan ist der Sohn eines britischen Lords und dessen Frau, die zu Beginn noch schwanger ist. Die beiden werden Opfer einer Meuterei, werden an der afrikanischen Küste ausgesetzt und richten sich dort ein. Sie bauen eine kleine Hütte, in der sie sich sicherer fühlen als im wilden Dschungel. Ihr Sohn erhält den Namen John Clayton III., Lord Greystoke. Die Mutter stirbt, als er ein Jahr alt ist; sein Vater lässt sein Leben im Kampf gegen eine Affenbande. Von da an heißt die Waise „Tarzan“ und wird von dieser Gruppe Affen aufgezogen, unter denen sich die Affenfrau Kala besonders um ihn kümmert. Ihren eigenen, zuvor vom Affenhäuptling getöteten Säugling legt sie stattdessen in die Wiege der kleinen Hütte. Tar-zan bedeutet „Weiße Haut“ in der Mangani-Sprache, der von Burroughs erschaffenen Affensprache.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Edgar Rice Burroughs\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Edgar Rice Burroughs (* 1. September 1875 in Chicago, Illinois; † 19. März 1950 in Encino, Kalifornien) war ein US-amerikanischer Schriftsteller. Burroughs wurde bekannt als Erzähler diverser fiktionaler Abenteuergeschichten der Trivialliteratur, die sich vor allem dem frühen Fantasy- und Science-Fiction-Genre zuordnen lassen. Die bekanntesten von ihm eingeführten und in der Folge von anderen in zahlreichen Filmen und Comics etablierten Heldencharaktere sind Tarzan und John Carter.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    OTB ebook\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0